(() => {
  let pending = false;
  const bestSellingRank = new Map();

  async function rankCartSuggestions() {
    const rail = document.querySelector('cart-drawer .gd-cart-upsell__rail');
    if (!rail || rail.dataset.gdRankingStarted) return;
    rail.dataset.gdRankingStarted = 'true';
    const cards = Array.from(rail.querySelectorAll('[data-gd-category][data-gd-product-handle]'));
    const categories = [...new Set(cards.map((card) => card.dataset.gdCategory))];
    if (!categories.length) return;

    const rankings = await Promise.all(categories.map(async (category) => {
      if (!bestSellingRank.has(category)) {
        bestSellingRank.set(category, fetch(`/collections/${encodeURIComponent(category)}?sort_by=best-selling`, {
          headers: { Accept: 'text/html' },
        }).then((response) => {
          if (!response.ok) throw new Error('Collection ranking unavailable');
          return response.text();
        }).then((html) => {
          const page = new DOMParser().parseFromString(html, 'text/html');
          const grid = page.querySelector('#product-grid, .product-grid');
          if (!grid) throw new Error('Collection product grid unavailable');
          const handles = [...grid.querySelectorAll('a[href*="/products/"]')].map((link) => {
            const match = new URL(link.href, location.origin).pathname.match(/\/products\/([^/]+)/);
            return match?.[1];
          }).filter(Boolean);
          return [...new Set(handles)];
        }).catch(() => []));
      }
      return bestSellingRank.get(category);
    }));

    if (!rail.isConnected) return;
    const chosen = new Set();
    const ordered = [];
    categories.forEach((category, index) => {
      const categoryCards = cards.filter((card) => card.dataset.gdCategory === category);
      const limit = Number(categoryCards[0]?.dataset.gdCategoryLimit || 0);
      const ranks = new Map(rankings[index].map((handle, position) => [handle, position]));
      categoryCards.sort((a, b) => (ranks.get(a.dataset.gdProductHandle) ?? Infinity) - (ranks.get(b.dataset.gdProductHandle) ?? Infinity));
      let categoryCount = 0;
      categoryCards.forEach((card) => {
        const selected = categoryCount < limit && !chosen.has(card.dataset.gdProductId);
        card.hidden = !selected;
        if (selected) {
          chosen.add(card.dataset.gdProductId);
          ordered.push(card);
          categoryCount += 1;
        }
      });
    });
    ordered.forEach((card) => rail.appendChild(card));
  }

  const suggestionObserver = new MutationObserver(() => rankCartSuggestions());
  suggestionObserver.observe(document.documentElement, { childList: true, subtree: true });
  rankCartSuggestions();

  async function updateCart(url, payload) {
    if (pending) return;
    pending = true;
    const drawer = document.querySelector('cart-drawer');
    const errorBox = drawer?.querySelector('#CartDrawer-CartErrors');
    if (errorBox) errorBox.textContent = '';

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          ...payload,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || !data.sections?.['cart-drawer']) {
        throw new Error(data.description || data.message || 'The cart could not be updated. Please try again.');
      }
      drawer?.renderContents(data);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'glimtiq-cart' });
      }
    } catch (error) {
      const currentErrorBox = document.querySelector('#CartDrawer-CartErrors');
      if (currentErrorBox) currentErrorBox.textContent = error.message;
      const gift = document.querySelector('[data-gd-gift-wrap]');
      if (gift) gift.checked = !gift.checked;
    } finally {
      pending = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gd-cart-add]');
    if (!button || pending) return;
    const variantId = Number(button.closest('.gd-cart-upsell__card')?.querySelector('[data-gd-cart-variant]')?.value || button.dataset.gdCartAdd);
    if (!variantId) return;
    button.disabled = true;
    updateCart(routes.cart_add_url, { items: [{ id: variantId, quantity: 1 }] }).finally(() => {
      if (button.isConnected) button.disabled = false;
    });
  });

  document.addEventListener('change', (event) => {
    const gift = event.target.closest('[data-gd-gift-wrap]');
    if (!gift || pending) return;
    const variantId = Number(gift.dataset.gdGiftWrap);
    if (!variantId) return;
    gift.disabled = true;
    const url = gift.checked ? routes.cart_add_url : routes.cart_update_url;
    const payload = gift.checked
      ? { items: [{ id: variantId, quantity: 1 }] }
      : { updates: { [variantId]: 0 } };
    updateCart(url, payload).finally(() => {
      if (gift.isConnected) gift.disabled = false;
    });
  });
})();
